<template>
  <div class="route-details-item"
       :class="{'route-details-item--is-template': isTemplate}"
       :tabindex="isTemplate ? 0 : -1"
       @click="onRootClick"
  >
    <div class="route-details-item__marker-container">
      <app-icon v-if="isTemplate"
                icon="route-new-coordinate"
      />

      <map-marker v-else
                  :coordinate="coordinate"
                  @marker-click="onMarkerClick"
      />
    </div>

    <p class="route-details-item__label">{{ label }}</p>

    <span v-if="isEditing"
          class="route-details-item__drag-handle"
    >
      <app-icon icon="drag-handle"/>
    </span>

    <span class="route-details-item__number">
      {{ number }}

      <button v-if="isEditing"
              class="route-details-item__remove-button"
              @click="removeCoordinate"
      />
    </span>
  </div>
</template>

<script>
import Coordinate from "@/models/Coordinate";
import Route from "@/models/Route";
import MapMarker from "@/components/common/TheMap/MapMarker.vue";
import { mapActions } from "vuex";

export default {
  name: "RouteDetailsItem",
  components: {
    MapMarker
  },
  props: {
    coordinate: {
      type: Coordinate,
      default: null
    },
    route: {
      type: Route,
      default: null
    },
    label: {
      type: String,
      default: null
    },
    number: {
      type: Number,
      required: true
    }
  },
  computed: {
    isTemplate() {
      return !this.coordinate
    },
    isEditing() {
      return this.route?.isEditing
    }
  },
  methods: {
    removeCoordinate() {
      this.removeCoordinateFromRoute({
        routeId: this.route?.id,
        coordinateId: this.coordinate.id,
        isNew: this.route?.isNew
      })
    },
    onRootClick() {
      if (this.isTemplate) {
        this.$root.$emit('map.fitMap')
      }
    },
    onMarkerClick() {
      this.setActiveCoordinateId(this.coordinate.id)
    },

    ...mapActions('Routes', ['removeCoordinateFromRoute']),
    ...mapActions('Coordinates', ['setActiveCoordinateId'])
  }
}
</script>

<style lang="scss">
.route-details-item {
  position: relative;
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 10px 0;
  height: 96px;

  &:not(:last-child):after {
    content: "";
    position: absolute;
    right: 15px;
    top: 75%;
    display: block;
    width: 2px;
    height: 50%;
    background-color: $app-primary-color;
  }

  &--is-template {
    cursor: pointer;
  }

  &__label {
    margin-right: auto;
    margin-left: 11px;
    font-size: 24px;
    font-weight: 500;
    max-width: 180px;
    color: $input-title-color;
    overflow: hidden;
    text-overflow: ellipsis;
  }

  &__drag-handle {
    padding: 8px 6px;
    margin: 2px 6px 0;
    cursor: grab;
  }

  &__number {
    position: relative;
    min-width: 32px;
    height: 32px;
    display: flex;
    align-items: center;
    justify-content: center;
    border: 2px solid $app-primary-color;
    border-radius: 50%;
    color: $app-primary-color;
    font-size: 20px;
    font-weight: 500;
    overflow: hidden;
  }

  &__remove-button {
    position: absolute;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
    cursor: pointer;
    background-color: $app-block-color;
    border: 2px solid transparent;
    border-radius: 50%;
    transform: rotate(45deg);
    opacity: 0;
    transition: opacity .3s;

    &:before,
    &:after {
      content: "";
      position: absolute;
      display: block;
      background-color: $app-primary-color;
    }
    &:before {
      height: 100%;
      width: 2px;
      top: 0;
      left: calc(50% - 1px);
    }
    &:after {
      height: 2px;
      width: 100%;
      top: calc(50% - 1px);
      left: 0;
    }
  }

  &:hover &__remove-button {
    opacity: 1;
  }

}
</style>